/* v29 (owner, 2026-10-28: the setup guide, "do the same"): the guide's step menu follows the reader (sections/dex-guide,
   dex-v33.css). The step in the middle of the screen is lit and its menu entry marked (earlier ones as done, the
   active one scrolled into the menu's view), a line under the menu fills as you read, and the menu stays clear of the
   site's sticky header. */
(function () {
  document.querySelectorAll('[data-dex-guide]').forEach(function (guide) {
    var toc = guide.querySelector('.dex-guide__toc');
    var steps = Array.prototype.slice.call(guide.querySelectorAll('.dex-gstep'));
    if (!toc || !steps.length) return;
    var links = Array.prototype.slice.call(toc.querySelectorAll('a'));
    var header = document.querySelector('sticky-header, .section-header');
    var current = -1;
    var mark = function (i) {
      if (i === current) return;
      current = i;
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      links.forEach(function (a, k) {
        a.classList.toggle('is-active', k === i);
        a.classList.toggle('is-done', k < i);
        if (k === i) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current');
      });
      var a = links[i];
      if (a && toc.scrollWidth > toc.clientWidth) toc.scrollTo({ left: a.offsetLeft - toc.clientWidth / 2 + a.offsetWidth / 2, behavior: 'smooth' });
    };
    var tick = function () {
      var mid = window.innerHeight * 0.45;
      var first = steps[0].getBoundingClientRect();
      var last = steps[steps.length - 1].getBoundingClientRect();
      var i = -1;
      steps.forEach(function (s, k) { if (s.getBoundingClientRect().top <= mid) i = k; });
      mark(first.top > mid ? -1 : i);
      var p = (mid - first.top) / Math.max(1, last.bottom - first.top);
      toc.style.setProperty('--dex-gp', Math.min(1, Math.max(0, p)).toFixed(3));
      // keep the menu under the site's header while that header is on screen
      var hb = header ? header.getBoundingClientRect().bottom : 0;
      toc.style.setProperty('--dex-toc-top', (Math.max(0, hb) + 12) + 'px');
    };
    var raf = 0;
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; tick(); }); }, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  });
})();
